const OnlyForSuperUser = ({ user, yes, no }) => {
  if (user?.super) {
    return typeof yes === 'function' ? yes() : null;
  }
  return typeof no === 'function' ? no() : null;
};

OnlyForSuperUser.defaultProps = {
  user: {},
  yes: null,
  no: null,
};

export default OnlyForSuperUser;
